export const POST_POLICY = 'termsOrPolicy';

